import { User } from '@angular/fire/auth';
import { Timestamp } from '@angular/fire/firestore';

export interface PersonalData {
	firstName?: string;
	lastName?: string;
	birthday?: string;
	phone?: string;
	dni?: string;
	genre?: Genre;
	profilePic?: string;
}

export enum Genre {
	Male = 'M',
	Female = 'F',
	Other = 'O',
	Undefined = 'U',
}

export interface Level {
	min: number;
	max: number;
	label: string;
}

export enum LevelEnum {
	Bebe_carpincho = 'Bebe_carpincho',
	Carpinchito = 'Carpinchito',
	Carpincho = 'Carpincho',
	Carpinchote = 'Carpinchote',
	Megacarpincho = 'Megacarpincho',
}

export const Levels: Record<LevelEnum, Level> = {
	Bebe_carpincho: {
		min: 0,
		max: 999,
		label: 'Bebe carpincho',
	},
	Carpinchito: {
		min: 1000,
		max: 1999,
		label: 'Carpinchito',
	},
	Carpincho: {
		min: 2000,
		max: 4499,
		label: 'Carpincho',
	},
	Carpinchote: {
		min: 4500,
		max: 9999,
		label: 'Carpinchote',
	},
	Megacarpincho: {
		min: 10000,
		max: Infinity,
		label: 'Megacarpincho',
	},
};

export type Role = 'superadmin' | 'admin' | 'staff' | 'user';

export class UserModel {
	// Basic properties
	id!: string;
	companyId!: string;
	accountName!: string;
	email!: string;
	fromStaff?: string;
	photoUrl?: string = '';
	createdAt: Timestamp = Timestamp.now();
	updatedAt: Timestamp = Timestamp.now();
	lastLoginAt?: Timestamp = Timestamp.now();
	personalData: PersonalData = {
		firstName: '',
		lastName: '',
		birthday: '',
		phone: '',
		dni: '',
	};
	score?: number = 0;
	role: Role = 'user';

	// Constructor
	public constructor(init?: Partial<UserModel>) {
		Object.assign(this, init);
	}

	// Static methods
	public static fromFirebaseUser(
		firebaseUser: User,
		userDoc?: UserModel
	): UserModel {
		const { uid, displayName, email, photoURL } = firebaseUser;

		if (userDoc?.id === uid) {
			return {
				...userDoc,
				lastLoginAt: Timestamp.now(),
				personalData: {
					...userDoc.personalData,
					firstName: userDoc.personalData?.firstName ?? '',
					lastName: userDoc.personalData?.lastName ?? '',
					birthday: userDoc.personalData?.birthday ?? '',
					phone: userDoc.personalData?.phone ?? '',
					dni: userDoc.personalData?.dni ?? '',
					genre: userDoc.personalData?.genre ?? Genre.Undefined,
				},
				role: userDoc.role ?? 'user',
			};
		}

		return new UserModel({
			id: uid,
			accountName: displayName ?? '',
			email: email ?? '',
			photoUrl: photoURL ?? '',
			createdAt: Timestamp.now(),
			updatedAt: Timestamp.now(),
			lastLoginAt: Timestamp.now(),
			personalData: {
				firstName: '',
				lastName: '',
				birthday: '',
				phone: '',
				dni: '',
				genre: Genre.Undefined,
			},
			role: 'user',
		});
	}
}
